import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-modal-footer",
  templateUrl: "./modal-footer.component.html",
  styleUrls: ["./modal-footer.component.sass"],
})
export class ModalFooterComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
